// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2ZllN","filesListContainer":"PosDisputesFiles_filesListContainer__FKknr","filesButton":"PosDisputesFiles_filesButton__uDV4J"};